import React from 'react';
import { Chip } from 'primereact/chip';
import { isArray } from 'lodash';
import moment from 'moment';

const FilterChip = ({ filter, formRef, values, label, name1, name2 }) => {
  const joinIfArray = (name) => {
    return isArray(values[name]) ? values[name].join(', ') : values[name];
  };

  if (filter?.fields?.[0]?.componentProps?.timeOnly && name1 && values[name1]) {
    values[name1] = moment(values[name1]).format('hh:mm');
  }

  if (filter?.fields?.[1]?.componentProps?.timeOnly && name2 && values[name2]) {
    values[name2] = moment(values[name2]).format('hh:mm');
  }
  return (
    (values[name1] || values[name2]) && (
      <Chip
        style={{
          color: 'black',
          padding: ' 8px',
          borderRadius: '8px',
          background: 'rgba(207, 219, 221, 0.59)',
          textTransform: 'capitalize',
        }}
        removeIcon={'pi pi-times'}
        label={
          <label
            style={{
              maxWidth: '380px',
              textOverflow: 'ellipsis',
              overflow: 'hidden',
              display: 'block',
            }}
          >
            <b>{label}: </b>
            {values[name1]?.label ?? joinIfArray(name1)}
            {values[name2] ? ' - ' + joinIfArray(name2) : ''}
          </label>
        }
        removable
        onRemove={(e) => {
          name1 && formRef.current.setFieldValue(name1, '');
          name2 && formRef.current.setFieldValue(name2, '');
          formRef.current.submitForm();
        }}
      />
    )
  );
};

export default FilterChip;
